import React, { useState } from 'react';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import { landingTheme } from '../../theme/landingTheme';

// Import landing page components
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { FeaturesSection } from './components/FeaturesSection';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { DemoRequestModal } from './components/DemoRequestModal';

export const LandingPage: React.FC = () => {
  const [demoModalOpen, setDemoModalOpen] = useState(false);

  const handleOpenDemo = () => {
    setDemoModalOpen(true);
  };

  const handleCloseDemo = () => {
    setDemoModalOpen(false);
  };

  return (
    <ThemeProvider theme={landingTheme}>
      <CssBaseline />
      <Box
        sx={{
          minHeight: '100vh',
          backgroundColor: 'background.default',
          // Add smooth scroll behavior
          '& html': {
            scrollBehavior: 'smooth',
          },
        }}
      >
        {/* Navigation */}
        <Navbar onRequestDemo={handleOpenDemo} />

        {/* Hero Section */}
        <HeroSection onRequestDemo={handleOpenDemo} />

        {/* Features Section */}
        <FeaturesSection />

        {/* Pricing Section */}
        <PricingSection onRequestDemo={handleOpenDemo} />

        {/* Testimonials Section */}
        <TestimonialsSection />

        {/* CTA Section */}
        <CTASection onRequestDemo={handleOpenDemo} />

        {/* Footer */}
        <Footer />

        {/* Demo Request Modal */}
        <DemoRequestModal open={demoModalOpen} onClose={handleCloseDemo} />
      </Box>
    </ThemeProvider>
  );
};

export default LandingPage;
